import React, { useState, useRef, useEffect } from 'react';
import { FaExternalLinkAlt } from 'react-icons/fa';

const projects = [
  {
    id: 1,
    title: 'Air BriefWise',
    description: 'Proyecto Fin de Ciclo, aplicación de gestión de planes de vuelo manejado por una API hecha en Python con FLASK. El proyecto está hecho en Kotlin e incluye un modelo generativo de google (gemini 1.5-flash) para las respuestas de un chatbot de asistencia',
    imageUrl: '/abw.png',
    technologies: ['Kotlin', 'Python', 'Flask', 'Gemini AI']
  },
  {
    id: 2,
    title: 'Android-Mirroring',
    description: 'Proyecto que proporciona una interfaz sencilla para gestionar las conexiones e iniciar la herramienta de screen mirroring Scrcpy. Soporta métodos de conexión USB y Wi-Fi para dispositivos Android.',
    imageUrl: '/androidconec.png',
    url: 'https://github.com/Danim299/Android-Mirroring',
    technologies: ['Android', 'Scrcpy']
  },
  {
    id: 3,
    title: 'DemoTranslator',
    description: 'Traductor que recoge audios y los traduce con inteligencia artificial. Hecho con gradio, translate, whisper y elevenlabs',
    imageUrl: '/demotranslator.png',
    url: 'https://github.com/Danim299/DemoTranslator',
    technologies: ['Python', 'Gradio', 'Whisper AI']
  },
  {
    id: 4,
    title: 'Portfolio',
    description: 'Portfolio hecho con React y Tailwind',
    imageUrl: '/portfolioimg.png',
    technologies: ['React', 'Tailwind CSS']
  },
  {
    id: 5,
    title: 'Bot Discord',
    description: 'Bot multifuncional, que destaca por hacer copias de seguridad de un canal del servidor y guardarlos en archivos JSON para luego poder recuperarlos. El proyecto está realizado en Python',
    imageUrl: '/botbackup.png',
    technologies: ['Python', 'Discord API']
  },
  {
    id: 6,
    title: 'Mazmorra',
    description: 'Proyecto final 1 DAM. Consiste en un juego de decisiones, adentrandote en mazmorras donde va a influir los objetos que lleves contigo. Hecho en Java',
    imageUrl: '/mazimg.png',
    technologies: ['Java']
  },
  {
    id: 7,
    title: 'Calculadora',
    description: 'Calculadora hecha en kotlin',
    imageUrl: '/calcimg.png',
    technologies: ['Kotlin', 'Android']
  },
  {
    id: 8,
    title: 'Juego Tablero',
    description: 'Juego de tablero estilo OCA, diseñado para niños de 4 ESO, abarcando la asignatura de historia. Hecho en Java',
    imageUrl: '/tableroimg.png',
    technologies: ['Java']
  },
  {
    id: 9,
    title: 'Biblioteca digital',
    description: 'Esta aplicación tiene la misma función que cualquier biblioteca real mediante una interfaz hecha con las librerias tkinter. El proyecto está hecho en su totalidad con Python',
    imageUrl: '/dinalib.png',
    technologies: ['Python', 'Tkinter']
  }
];

const featuredIds = [1, 2, 3];

const Projects = () => {
  const [showAll, setShowAll] = useState(false);
  const sliderRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Detectar cambios en el scroll
  const handleScroll = () => {
    if (!sliderRef.current) return;
    
    const slider = sliderRef.current;
    const scrollPosition = slider.scrollLeft;
    const cardWidth = slider.firstChild?.clientWidth || 0;
    
    if (cardWidth > 0) {
      const newIndex = Math.round(scrollPosition / cardWidth);
      setCurrentIndex(newIndex);
    }
  };

  // Configurar event listener
  useEffect(() => {
    const slider = sliderRef.current;
    if (slider) {
      slider.addEventListener('scroll', handleScroll);
      return () => slider.removeEventListener('scroll', handleScroll);
    }
  }, []);

  const scrollToIndex = (index) => {
    if (sliderRef.current) {
      const cards = sliderRef.current.querySelectorAll('.project-card');
      if (cards.length > index) {
        cards[index].scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start'
        });
      }
    }
  };

  const handleNext = () => {
    const nextIndex = currentIndex + 1;
    if (nextIndex < featuredProjects.length) {
      scrollToIndex(nextIndex);
    }
  };

  const handlePrev = () => {
    const prevIndex = currentIndex - 1;
    if (prevIndex >= 0) {
      scrollToIndex(prevIndex);
    }
  };

  const featuredProjects = projects.filter(project =>
    featuredIds.includes(project.id)
  );

  const otherProjects = projects.filter(project =>
    !featuredIds.includes(project.id)
  );

  return (
    <div className="p-6 bg-transparent rounded-lg">
      <h2 className="text-3xl font-bold text-pastel-yellow mb-8 text-center">
        Mis Proyectos
      </h2>

      {/* Proyectos destacados - Desktop */}
      <div 
        className="hidden md:grid grid-cols-1 md:grid-cols-3 gap-6 mb-8"
        style={{ gridAutoRows: '1fr' }}
      >
        {featuredProjects.map((project) => (
          <ProjectCard key={project.id} project={project} />
        ))}
      </div>

      {/* Proyectos destacados - Mobile (Slider con scroll snap) */}
      <div className="md:hidden mb-8">
        <div className="relative">
          <div 
            ref={sliderRef}
            className="flex overflow-x-auto snap-x snap-mandatory hide-scrollbar scroll-smooth"
            style={{ 
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
              WebkitOverflowScrolling: 'touch'
            }}
          >
            {featuredProjects.map((project) => (
              <div 
                key={project.id} 
                className="flex-shrink-0 w-full snap-start project-card"
              >
                <div className="px-4 pb-4">
                  <ProjectCard project={project} />
                </div>
              </div>
            ))}
          </div>

          {/* Flechas de navegación */}
          {currentIndex > 0 && (
            <button
              onClick={handlePrev}
              className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-pastel-yellow rounded-full w-8 h-8 flex items-center justify-center text-gray-900 shadow-lg z-10 hover:bg-yellow-400 transition-all"
              aria-label="Proyecto anterior"
            >
              &larr;
            </button>
          )}
          
          {currentIndex < featuredProjects.length - 1 && (
            <button
              onClick={handleNext}
              className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-pastel-yellow rounded-full w-8 h-8 flex items-center justify-center text-gray-900 shadow-lg z-10 hover:bg-yellow-400 transition-all"
              aria-label="Proyecto siguiente"
            >
              &rarr;
            </button>
          )}
        </div>
      </div>

      {/* Botón mostrar todos */}
      {!showAll && (
        <div className="text-center mb-8">
          <button
            onClick={() => setShowAll(true)}
            className="px-6 py-2 bg-pastel-yellow text-gray-900 font-medium rounded-lg hover:bg-yellow-400 transition-colors flex items-center justify-center mx-auto"
          >
            Mostrar todos los proyectos
          </button>
        </div>
      )}

      {/* Mostrar todos */}
      {showAll && (
        <div>
          <div 
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8"
            style={{ gridAutoRows: '1fr' }}
          >
            {otherProjects.map((project) => (
              <ProjectCard key={project.id} project={project} />
            ))}
          </div>
          <div className="text-center">
            <button
              onClick={() => setShowAll(false)}
              className="px-6 py-2 bg-pastel-yellow text-gray-900 font-medium rounded-lg hover:bg-yellow-400 transition-colors flex items-center justify-center mx-auto"
            >
              Mostrar menos
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

// Tarjeta individual
const ProjectCard = ({ project }) => {
  return (
    <div className="flex flex-col h-full min-h-[450px] border-2 border-neutral-700 rounded-lg overflow-hidden bg-neutral-750 hover:border-pastel-yellow transition-colors">
      {/* Imagen */}
      <div className="relative h-48 overflow-hidden">
        <img
          src={project.imageUrl}
          alt={project.title}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
      </div>

      {/* Contenido */}
      <div className="flex flex-col flex-grow p-4">
        <div className="flex justify-between items-start mb-2">
          <h3 className="text-xl font-semibold text-white">{project.title}</h3>
          {project.url && (
            <a
              href={project.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-pastel-yellow hover:text-yellow-400 transition-colors"
            >
              <FaExternalLinkAlt />
            </a>
          )}
        </div>

        <p className="text-gray-300 text-sm mb-4 flex-grow overflow-auto">
          {project.description}
        </p>

        <div className="flex flex-wrap gap-2 mt-auto">
          {project.technologies.map((tech, index) => (
            <span
              key={index}
              className="px-2 py-1 bg-pastel-yellow text-xs text-gray-900 rounded-full"
            >
              {tech}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;